import React from 'react'
import Avatar from 'shared-web/src/components/Avatar'
import DefaultAvatarImageUri from 'shared-web/src/components/Avatar/images/default-avatar.svg'
import styles from './styles.styl'

export const CardLayoutPreview = ({ user }) => (
  <div className={styles.CardLayoutPreviewContainer}>
    <div className={styles.CardLayoutPreview}>
      <header>
        <Avatar shape='circle' user={user}/>
        <h1/>
      </header>
      <div className='bg-gray-extra-light'>
        <p/>
        <p/>
      </div>
      <div>
        <p/>
        <p/>
      </div>
    </div>
  </div>
)

export const WideLayoutPreview = ({
  coverPhotoUrl,
}) => (
  <div className={styles.WideLayoutPreviewContainer}>
    <header
      className={styles['WideLayoutPreview__Header']}
      style={{ backgroundImage: coverPhotoUrl ? `url(${coverPhotoUrl})` : undefined }}
    >
      {!coverPhotoUrl && <img src={DefaultAvatarImageUri}/>}
      <div>
        <p/>
        <p/>
      </div>
    </header>
    <div className={styles['WideLayoutPreview__Content']}>
      <h1/>
      <p/>
      <p/>
      <div className='flex flex-space-between'>
        <div style={{
          width: '48%',
          border: '1px solid currentColor',
          background: 'currentColor',
        }}/>
        <div style={{
          width: '48%',
          border: '1px solid currentColor',
          background: 'none',
        }}/>
      </div>
      <p/>
      <p/>
      <p/>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/UserProfile/Sections/Profile/ThemeInfo/ProfileLayoutPreview/index.js